export function isGuest(state) {
	return state.guest;
}

export function applicantType(state) {
	return state.applicantType;
}

export function studentType(state) {
	return state.studentType;
}

export function institutions(state) {
	return state.institutions;
}

export function userSetup(state) {
	return state.userSetup;
}

export function isLoggedIn(state) {
	return state.loggedIn;
}

export function continuingApplication(state) {
	return state.continuingForm;
}

export function email(state) {
	return state.email;
}

export function userType(state) {
	return state.userType;
}
